<template>
    <div class="col-md-6">
        <div v-for="(tax,index) of taxrates">
            <label class="attribute-label m-bottom-12" v-if="taxIncluded">Tax Included ({{ tax.tax_rate_value }}%)</label>
            <label class="attribute-label m-bottom-12" v-else>Total Tax ({{ tax.tax_rate_value }}%)</label>

            <div class="input-group width-100">

                <input type="number" step="0.01"  v-if="!minimumChargeEnabled" class="form-control price-new-inputs" :value="tax.value" readonly disabled>
                <input type="number" step="0.01"  v-else class="form-control price-new-inputs" :value="tax.valueWithMinimumCharge" readonly disabled>

                <input type="hidden" id="gst_percentage" name="gst_percentage"  :value="tax.tax_rate_value" readonly >


                <span class="input-group-addon input-group-addon-new-design"
                      style="background-color: #F5F5F6 !important;">
                <b> {{ currency.currency_symbol }} </b>
            </span>
            </div>
        </div>
    </div>
</template>

<script>

import _ from 'lodash'

export default {
    name: "BookingTaxFields",
    props: ['taxes','taxIncluded','minimumChargeEnabled','currency','cancellationFee','callOutFee'],
    computed: {
        taxrates() {
          //group taxes  on value not on id because there is some companies has same values with different ids
            return _(this.taxes).groupBy('tax_rate_value').map(grouped => {
                let sum = 0;
                let sumWithMinimumCharge = 0;
                
                for (let item of grouped) {
                    sum += (item || {}).value
                    sumWithMinimumCharge += (item || {}).valueWithMinimumCharge
                }

                let result = {
                    value: 0,
                    valueWithMinimumCharge: 0,
                    ...grouped[0]
                }
                if (this.cancellationFee || this.callOutFee){
                    result.value = 0
                    result.valueWithMinimumCharge = 0
                }else{
                    result.value = parseFloat(sum).toFixed(2)
                    result.valueWithMinimumCharge = parseFloat(sumWithMinimumCharge).toFixed(2)
                }

                
                return result
            }).value()
        },
        totalTax() {
            let sum = 0;
            for(let tax of this.taxes){
                if(this.cancellationFee)
                    sum += 0
                else if(this.minimumChargeEnabled)
                    sum += tax.valueWithMinimumCharge
                else
                    sum += tax.value
            }
            return sum
        }
    },
    watch: {
        totalTax(value) {
            this.$emit('input', value)
        }
    }
}
</script>

<style scoped>

</style>